import React from 'react';
import { useTranslation } from 'react-i18next';
import { Persona } from '../../types'; // Décommenter l'import
import PersonaAvatar from '../Common/PersonaAvatar';

interface PersonaCardProps {
  persona: Persona;
  onClick: () => void;
}

const PersonaCard: React.FC<PersonaCardProps> = ({ persona, onClick }) => { // Décommenter les props et le type
  const { t } = useTranslation();
  return (
    <div
      className="border rounded-lg p-4 shadow hover:shadow-md cursor-pointer transition-shadow"
      onClick={onClick} // Ajouter l'événement onClick
    >
      <div className="flex items-center space-x-3 mb-2">
         {/* Utiliser le composant partagé PersonaAvatar */}
         <PersonaAvatar persona={persona} size="md" />
         <div>
           <p className="text-sm font-medium text-gray-900 dark:text-slate-50">{persona.name}</p> {/* Afficher le nom réel */}
           <p className="text-xs text-gray-500">{persona.role}</p> {/* Afficher le rôle réel */}
         </div>
      </div>
      <p className="text-sm text-gray-600 italic">
        {persona.citation ? `"${persona.citation}"` : t('persona.noCitation')} {/* Utiliser citation */}
      </p>
    </div>
  );
};

export default PersonaCard;
